import React from "react";
import NavBar from "../../Components/Navbar/index";
import Footer from "../../Components/Footer";
import "./index.css";

const PolicyPrivacyPage = () => {
  return (
    <div>
      <NavBar changeColor="true" />
      <div className="privacy-policy">
        <h1>Termos de uso da Plataforma Merx Energia</h1>

        <h6>Fevereiro de 2026</h6>

        <section className="policy-section">
          <p>
            Estes Termos de Uso ("Termos") regem o uso da plataforma digital da
            Merx Energia ("Plataforma") fornecida pela Merx Energia
            ("Prestadora", "nós", "nosso(a)") aos usuários ("Usuário", "você",
            "seu(sua)"). Ao utilizar a Plataforma, você concorda em cumprir e
            estar vinculado a estes Termos. Se você não concordar com estes
            Termos, recomendamos que não utilize nossa Plataforma.
          </p>
        </section>

        <section className="policy-section">
          <h2>DESCRIÇÃO DO SERVIÇO</h2>
          <p>
            <strong>1.1.</strong> A Plataforma é uma ferramenta digital que
            oferece informações e funcionalidades relacionadas ao consumo de
            energia elétrica, permitindo que os Usuários monitorem e controlem
            seu consumo por meio de dispositivos compatíveis.
            <br />
            <br />
            <strong>1.2.</strong> A Plataforma é disponibilizada "no estado em
            que se encontra" e "conforme disponibilidade". Não garantimos que a
            Plataforma estará sempre disponível, sem interrupções, atrasos,
            erros ou omissões. Podemos, a nosso critério, modificar, atualizar,
            suspender ou encerrar a Plataforma a qualquer momento.
          </p>
        </section>

        <section className="policy-section">
          <h2>RESPONSABILIDADES DO USUÁRIO</h2>
          <p>
            <strong>2.1.</strong> O Usuário é o único responsável pelo uso
            adequado e seguro da Plataforma e pelas informações fornecidas. Você
            deve garantir que todas as informações fornecidas sejam precisas,
            atualizadas e completas.
            <br />
            <br />
            <strong>2.2.</strong> Ao utilizar a Plataforma, o Usuário concorda
            em cumprir todas as leis, regulamentos e diretrizes aplicáveis
            relacionadas ao uso de energia elétrica, incluindo, mas não se
            limitando a, leis de consumo, tarifas e normas técnicas.
            <br />
            <br />
            <strong>2.3.</strong> O Usuário concorda em não utilizar a
            Plataforma para qualquer finalidade ilegal, fraudulenta,
            difamatória, abusiva, invasiva da privacidade de terceiros, obscena,
            ofensiva, ameaçadora ou prejudicial de qualquer forma.
          </p>
        </section>

        <section className="policy-section">
          <h2>ISENÇÃO DE RESPONSABILIDADE</h2>
          <p>
            <strong>3.1.</strong> A Prestadora não se responsabiliza por
            quaisquer danos, perdas ou lesões resultantes do uso ou incapacidade
            de uso da Plataforma. Em nenhuma circunstância seremos responsáveis
            por danos diretos, indiretos, incidentais, consequenciais,
            exemplares, punitivos ou especiais, incluindo, mas não se limitando
            a, perda de lucros, dados, uso, economias previstas, reputação ou
            outras perdas intangíveis, mesmo que tenhamos sido informados sobre
            a possibilidade de tais danos.
            <br />
            <br />
            <strong>3.2.</strong> Não garantimos a precisão, integridade ou
            confiabilidade das informações disponibilizadas na Plataforma. As
            informações são fornecidas apenas para fins informativos e não devem
            ser consideradas como aconselhamento profissional. O Usuário é
            responsável por verificar a precisão e adequação das informações
            antes de tomar qualquer decisão ou agir com base nelas.
            <br />
            <br />
            <strong>3.3.</strong> Não nos responsabilizamos por quaisquer
            problemas técnicos, falhas de segurança, interrupções na
            disponibilidade da Plataforma ou por qualquer dano ao dispositivo do
            Usuário resultante do uso da Plataforma, incluindo, mas não se
            limitando a, atrasos na transmissão de dados, vírus de computador,
            acesso não autorizado ou qualquer outro problema resultante do uso
            da internet.
          </p>
        </section>

        <section className="policy-section">
          <h2>PROPRIEDADE INTELECTUAL</h2>
          <p>
            <strong>4.1.</strong> Todos os direitos de propriedade intelectual
            relacionados à Plataforma, incluindo, mas não se limitando a, marcas
            registradas, direitos autorais, segredos comerciais e patentes, são
            de propriedade exclusiva da Prestadora ou licenciados para nós.
            Nenhum conteúdo presente na Plataforma deve ser copiado,
            reproduzido, modificado, distribuído ou usado de qualquer forma sem
            nossa autorização prévia por escrito.
          </p>
        </section>

        <section className="policy-section">
          <h2>MODIFICAÇÕES DOS TERMOS DE USO</h2>
          <p>
            <strong>5.1.</strong> Reservamo-nos o direito de modificar ou
            atualizar estes Termos a qualquer momento, sem aviso prévio. A
            versão atualizada dos Termos será publicada na Plataforma, e o uso
            continuado da Plataforma após a publicação das modificações
            constitui aceitação dos Termos atualizados.
          </p>
        </section>

        <section className="policy-section">
          <h2>DISPOSIÇÕES GERAIS</h2>
          <p>
            <strong>6.1.</strong> Caso qualquer disposição destes Termos seja
            considerada inválida ou inexequível, as demais disposições
            permanecerão em pleno vigor e efeito.
          </p>
        </section>

        <section className="policy-section">
          <h2>PRIVACIDADE E PROTEÇÃO DE DADOS</h2>
          <p>
            <strong>7.1.</strong> A Prestadora valoriza a privacidade dos
            Usuários. Ao utilizar a Plataforma, você concorda com a coleta, uso
            e divulgação de informações conforme estabelecido em nossa Política
            de Privacidade, em pleno acordo com a Lei nº 13.709/2018 ("Lei Geral
            de Proteção de Dados Pessoais" ou "LGPD"). Recomendamos que você
            leia atentamente a Política de Privacidade para compreender como
            tratamos suas informações pessoais.
            <br />
            <br />
            <strong>7.2.</strong> O Usuário reconhece e concorda que, apesar de
            implementarmos medidas de segurança adequadas, a transmissão de
            dados pela internet não é totalmente segura e não podemos garantir a
            segurança absoluta das informações transmitidas por meio da
            Plataforma.
          </p>
        </section>

        <section className="policy-section">
          <h2>LINKS PARA SITES DE TERCEIROS</h2>
          <p>
            <strong>8.1.</strong> A Plataforma pode conter links para sites de
            terceiros. Esses links são fornecidos apenas para sua conveniência,
            e não temos controle sobre o conteúdo desses sites. Não nos
            responsabilizamos pela disponibilidade, conteúdo, produtos, serviços
            ou práticas de privacidade dos sites de terceiros. O acesso e uso
            desses sites estão sujeitos aos termos e condições específicos de
            cada site.
          </p>
        </section>

        <section className="policy-section">
          <h2>RESCISÃO</h2>
          <p>
            <strong>9.1.</strong> A Prestadora pode, a seu exclusivo critério,
            rescindir ou suspender seu acesso à Plataforma, total ou
            parcialmente, a qualquer momento, por qualquer motivo, incluindo,
            mas não se limitando a, violação destes Termos.
            <br />
            <br />
            <strong>9.2.</strong> Em caso de rescisão, as disposições destes
            Termos que, por sua natureza, devam sobreviver à rescisão,
            permanecerão em pleno vigor e efeito.
          </p>
        </section>

        <section className="policy-section">
          <h2>DISPOSIÇÕES FINAIS</h2>
          <p>
            <strong>10.1.</strong> Estes Termos representam o acordo integral
            entre a Prestadora e o Usuário em relação ao uso da Plataforma,
            substituindo qualquer acordo anterior.
            <br />
            <br />
            <strong>10.2.</strong> A falha da Prestadora em exercer ou aplicar
            qualquer direito ou disposição destes Termos não constituirá uma
            renúncia a tal direito ou disposição.
            <br />
            <br />
            <strong>10.3.</strong> Caso alguma disposição destes Termos seja
            considerada inválida ou inexequível, tal disposição será limitada ou
            eliminada na medida mínima necessária, e as demais disposições
            destes Termos permanecerão em pleno vigor e efeito.
            <br />
            <br />
            <strong>10.4.</strong> Estes Termos não criam qualquer forma de
            associação, parceria, joint venture, emprego ou representação entre
            a Prestadora e o Usuário.
            <br />
            <br />
            Ao continuar a utilizar nossa Plataforma digital de energia
            elétrica, você concorda e aceita todos os termos e condições
            estabelecidos nestes Termos de Uso. Se você tiver alguma dúvida ou
            preocupação, entre em contato conosco por meio dos canais de suporte
            disponibilizados na Plataforma.
          </p>
        </section>

        <section className="policy-section">
          <h2>INDENIZAÇÃO</h2>
          <p>
            <strong>11.1.</strong> O Usuário concorda em indenizar, defender e
            isentar a Prestadora, seus diretores, funcionários, afiliados,
            agentes e contratados de qualquer reclamação, ação, demanda,
            responsabilidade, custo ou despesa, incluindo honorários
            advocatícios razoáveis, decorrentes de qualquer violação destes
            Termos por parte do Usuário ou do uso indevido da Plataforma.
          </p>
        </section>

        <section className="policy-section">
          <h2>NOTIFICAÇÕES</h2>
          <p>
            <strong>12.1.</strong> A Prestadora pode enviar notificações
            relacionadas à Plataforma por meio de comunicações eletrônicas, como
            e-mails ou mensagens dentro da própria Plataforma. O Usuário
            concorda em receber tais notificações eletronicamente e reconhece
            que tais comunicações eletrônicas satisfazem qualquer requisito
            legal de comunicação por escrito.
          </p>
        </section>

        <section className="policy-section">
          <h2>ALTERAÇÕES NOS TERMOS DE USO</h2>
          <p>
            <strong>13.1.</strong> A Prestadora reserva-se o direito de
            modificar ou atualizar estes Termos de Uso a qualquer momento, a seu
            exclusivo critério. Quaisquer alterações serão efetivas a partir da
            data de publicação dos Termos atualizados na Plataforma. O uso
            continuado da Plataforma após a publicação das alterações constitui
            sua aceitação dos Termos de Uso revisados.
          </p>
        </section>

        <section className="policy-section">
          <h2>LEI APLICÁVEL E JURISDIÇÃO</h2>
          <p>
            <strong>14.1.</strong> Estes Termos serão regidos e interpretados de
            acordo com as leis da República Federativa do Brasil.
            <br />
            <br />
            <strong>14.2.</strong> Qualquer disputa relacionada a estes Termos
            será submetida à jurisdição exclusiva dos tribunais competentes na
            cidade do Recife, no estado de Pernambuco, na República Federativa
            do Brasil, em que estamos sediados.
            <br />
            <br />
            Estes Termos de Uso estabelecem o acordo completo entre a Prestadora
            e o Usuário em relação ao uso da Plataforma de energia elétrica. Ao
            continuar a utilizar a Plataforma, você concorda em cumprir estes
            Termos. Se você não concordar com estes Termos, solicitamos que não
            utilize nossa Plataforma.
          </p>
        </section>

        <h1>Política de Privacidade</h1>

        <section className="policy-section">
          <h2>INTRODUÇÃO</h2>
          <p>
            A privacidade dos usuários de nossa plataforma é prioridade, sendo
            assim, esclarecemos nessa Política de Privacidade como serão
            tratadas suas informações. Ao acessar o site da Merx Energia
            (www.merxenergia.com.br), o usuário deve estar ciente de que o mesmo
            poderá conter links para outros endereços eletrônicos, sendo que
            esses poderão possuir políticas de privacidade próprias, diferentes
            das aplicadas pela Merx Energia.
          </p>
        </section>

        <section className="policy-section">
          <h2>COMO ENTRAR EM CONTATO</h2>
          <p>
            Caso tenha alguma pergunta relacionada a esta Política de
            Privacidade ou deseje entrar em contato por outro motivo, entre em
            contato com o suporte pelo e-mail plataforma@merxenergia.com.br.
          </p>
        </section>

        <section className="policy-section">
          <h2>INFORMAÇÕES QUE COLETAMOS</h2>
          <p>
            Você não é obrigado a fornecer qualquer informação pessoal a fim de
            visitar nosso website e/ ou visualizar certos recursos disponíveis
            no mesmo. Embora não seja obrigatório que o usuário faça o cadastro
            para navegar em nossa página, certos conteúdos e plataformas somente
            estarão disponíveis aos usuários cadastrados e ativos. O processo de
            criação de conta exige que você forneça uma série de dados pessoais,
            tais como nome, email, o número de seu telefone, CPF e uma senha. Em
            outras ocasiões, também é possível que você tenha de fornecer dados
            adicionais, como CNPJ, razão social, a fim de receber mais
            informações e customizações no site sobre nossos serviços. Para
            usuários cadastrados, salvamos as faturas enviadas em nosso
            simulador em um banco de dados, com o propósito de estudo e melhoria
            de nossos serviços em geral.
          </p>
        </section>

        <section className="policy-section">
          <h2>POLÍTICA DE COLETA AUTOMÁTICA DE DADOS</h2>
          <p>
            Tendo ou não se cadastrado no Website, a Merx Energia
            (www.merxenergia.com.br) poderá coletar dados enquanto você navega
            pelo site, dados esses que não te identificam pessoalmente, como
            velocidade de conexão, endereço de IP, localização geográfica, etc.
          </p>
        </section>

        <section className="policy-section">
          <h2>POLÍTICA DE COOKIES</h2>
          <p>
            Ao utilizar nosso Website, poderemos utilizar uma tecnologia comum
            no setor, chamada “cookies”, armazenando algumas informações em seu
            computador, as quais possibilitam uma navegação personalizada ao
            usuário, ou, até mesmo, facilitando sua navegação. A maioria dos
            navegadores permitem que o usuário apague esses arquivos de seu
            computador, no entanto, caso o usuário configure seu navegador para
            bloquear os cookies, a experiência de navegação poderá ficar
            prejudicada.
          </p>
        </section>

        <section className="policy-section">
          <h2>DEPOIMENTOS</h2>
          <p>
            A Merx Energia (www.merxenergia.com.br) pode postar em seu Website
            ou redes sociais depoimentos ou conteúdos os quais podem conter
            informações sobre nossos usuários. Ao concordar com os Termos de
            Serviço aplicáveis ao site, você está dando seu consentimento à Merx
            Energia (www.merxenergia.com.br), a publicar qualquer depoimento,
            post, comentário, nome e qualquer outro tipo de representação.
          </p>
        </section>

        <section className="policy-section">
          <h2>USO DE SUAS INFORMAÇÕES</h2>
          <p>
            Em geral, utilizaremos suas informações para aprimorar os nossos
            serviços e possibilitar que os nossos usuários desfrutem ao máximo
            de todos os conteúdos disponibilizados. A Merx Energia
            (www.merxenergia.com.br) poderá compartilhar essas informações com
            fornecedores de conteúdo do serviço, associados, parceiros,
            patrocinadores, coligadas, filiais e outras entidades, de forma
            não-pessoal, a fim de mapear dados demográficos, preferências gerais
            entre os usuários ou para outros fins. Esta informação pode incluir
            dados de uso e demográficos, informações pessoais (como seu endereço
            de e-mail), etc. Trabalhamos com terceiros que prestam serviços, que
            podem incluir serviços de natureza administrativa como hospedagem do
            website, processamento de pedidos, liberação de cartão de crédito,
            análise de dados, etc. Algumas informações do usuário poderão ser
            compartilhadas com estes terceiros, a fim de viabilizar o serviço a
            ser prestado. Caso o usuário deseje desativar sua conta, a Merx
            Energia (www.merxenergia.com.br) poderá reter alguma informação
            associada com as informações do perfil por um tempo comercialmente
            razoável para backup, arquivamento e/ou fins de auditoria.
          </p>
        </section>

        <section className="policy-section">
          <h2>EXCLUSÃO DE DADOS</h2>
          <p>
            Você pode solicitar a exclusão dos seus dados através do
            cancelamento da sua parceria com a Merx Energia
            (www.merxenergia.com.br) e ou de outros cadastros da Merx Energia
            (www.merxenergia.com.br) que você tenha (conforme aplicável) e a
            Merx Energia (www.merxenergia.com.br) fará a exclusão definitiva de
            seus dados em até 180 dias. Após a exclusão, a Merx Energia
            (www.merxenergia.com.br) poderá manter os seus dados somente:
            <br />
            <br />
            (a) pelo prazo necessário para fins de processos judiciais,
            administrativos e arbitrais;
            <br />
            <br />
            (b) para cumprimento de obrigação legal e/ou regulatória;
            <br />
            <br />
            (c) para o exercício regular de direitos, como, por exemplo, fazer
            valer os direitos da Merx Energia (www.merxenergia.com.br) com base
            no contrato de assinatura e/ou Termos de Uso aplicáveis;
            <br />
            <br />
            (d) em formato anonimizado;
            <br />
            <br />
            Você pode solicitar a remoção dos seus dados através do e-mail:
            plataforma@merxenergia.com.br
          </p>
        </section>

        <section className="policy-section">
          <h2>SEGURANÇA</h2>
          <p>
            A segurança de dados pessoais do usuário é muito importante para a
            Merx Energia (www.merxenergia.com.br). Assim, serão utilizadas as
            melhores práticas disponíveis no mercado para proteger as
            informações pessoais coletadas. Quando forem fornecidas informações
            sensíveis, como número de conta ou cartão de crédito, a Merx Energia
            (www.merxenergia.com.br) tomará as medidas comercialmente razoáveis
            para protegê-las, por meio de uma conexão segura com o seu navegador
            web. É indispensável que o usuário faça sua parte para ajudar a Merx
            Energia (www.merxenergia.com.br) a proteger suas informações.
            Mantenha sua senha em segurança e, se possível, não utilize dados
            pessoais na mesma. Não divulgue ela a ninguém.
          </p>
        </section>

        <section className="policy-section">
          <h2>LINKS PARA OUTROS SITES</h2>
          <p>
            O site da Merx Energia (www.merxenergia.com.br) poderá conter links
            para outros sites. A Merx Energia (www.merxenergia.com.br) procura
            utilizar-se dos mais diversos meios para proteção das informações do
            usuário. Contudo, a partir do momento que o usuário navegue por
            outros sites, o usuário estará por sua conta em risco, tendo em
            vista que a Merx Energia (www.merxenergia.com.br) não se
            responsabiliza pelas informações e conteúdos disponibilizados nos
            mesmos. Ainda, é primordial que os usuários tomem conhecimento das
            políticas adotadas pelos mesmos.
          </p>
        </section>

        <section className="policy-section">
          <h2>BANCO DE DADOS</h2>
          <p>
            A Merx Energia (www.merxenergia.com.br) poderá hospedar seu banco de
            dados em outro país. Sendo assim, ao submeter suas informações à
            nossa plataforma, o usuário está ciente que as mesmas poderão ser
            armazenadas em bancos de dados fora do Brasil. Ao utilizar nosso
            website, o usuário manifesta sua concordância com os termos dessa
            Política de Privacidade. Caso não concorde, não utilize nosso
            Website ou serviços nele estabelecidos. A presente política poderá
            ser alterada ao longo do tempo. O uso continuado do website após as
            alterações significa que o usuário aceita e concorda com as mudanças
            realizadas, as quais passarão a vigorar em substituição à anterior,
            inclusive, para as informações fornecidas pelo usuário anteriores às
            mudanças.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PolicyPrivacyPage;
